<template>
  <v-sheet class="currency-group-details" :class="$vuetify.theme.dark ? 'blue-darken-5 ' : 'white-lighten-1'">
    <v-card-text>
      <v-card-title class="pa-0"> Currency Group </v-card-title>
      <v-dialog transition="scale-transition" origin="center center" max-width="324" v-model="dialog"
        content-class="deposit-withdraw-popup currency-group-details-popup">
        <template v-slot:activator="{ on, attrs }">
          <v-btn tile small v-bind="attrs" v-on="on" elevation="0" :disabled="$canRoute('currency') !== 1" class="text-capitalize btn-account"
            color="teal-lighten-1">+New Group</v-btn>
        </template>

        <v-card class="rounded-0 pa-7" :class="$vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'">
          <v-card-title class="pb-3 text-left justify-start pl-3">
            Add New Group
          </v-card-title>
          <v-card-subtitle class="mt-0 pl-3 pb-0 pr-10 text--ash">
            To add new group, please write your new group name & save
          </v-card-subtitle>
          <v-card class="deposit-form px-3 py-4" :class="$vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'">
            <v-row>
              <v-col cols="12">
                <fieldset>
                  <legend>New Group*</legend>
                  <v-text-field label="Write Group Name" v-model="groupName" single-line solo hide-details
                    class="custom-select"></v-text-field>
                  <span v-if="isGroupClicked && !groupName" style="color: red; font-size: 12px; margin-top: 1px">Group
                    Name
                    field is required</span>
                </fieldset>
              </v-col>
            </v-row>
          </v-card>
          <v-card-actions class="mt-10">
            <v-row>
              <v-col cols="6">
                <v-btn tile block @click.prevent="handleCreateGroup" elevation="0" class="text-capitalize btn-account"
                  color="teal-lighten-1">Create</v-btn>
              </v-col>
              <v-col cols="6">
                <v-btn tile block outlined @click="dialog = false" elevation="0"
                  class="text-capitalize btn-account">Cancel</v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card-text>
  </v-sheet>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { CURRENCY__ACTIONS } from "@/store/action-types";
import toast from "@/services/Notification";

export default {
  data() {
    return {
      groupName: null,
      dialog: false,
      isGroupClicked: false,
    };
  },

  computed: {
    ...mapState("admins", ["loggedAdmin"]),
  },

  methods: {
    ...mapActions("currencies", [CURRENCY__ACTIONS.CREATEGROUP]),

    handleCreateGroup() {
      this.isGroupClicked = true;
      const parameter = {
        title: this.groupName.toUpperCase(),
      };
      if (this.groupName) {
        this[CURRENCY__ACTIONS.CREATEGROUP](parameter);
        this.groupName = null;
        this.dialog = false;
      }
    },
  },

};
</script>
